import { render } from "./OtherTypes.vue?vue&type=template&id=2d325ed6&scoped=true"
import script from "./OtherTypes.vue?vue&type=script&lang=js"
export * from "./OtherTypes.vue?vue&type=script&lang=js"

import "./OtherTypes.vue?vue&type=style&index=0&id=2d325ed6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/eoy-2022-frontend/eoy-2022-frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d325ed6"]])

export default __exports__